/* eslint-disable import/no-cycle */
import React, { forwardRef } from 'react';
import s from 'styled-components';
import cn from 'classnames';
import InputMask from 'react-input-mask';
import { Styles } from 'components/form/Input';

const FormFieldMaskedContainer = s(InputMask)`
  ${Styles}
  background-color: unset;
  border: unset;

  &:focus {
    color: unset;
    background-color: unset;
    border-color: unset;
  }

  &:hover {
    border-color: unset;
  }
`;

const FormFieldMasked = forwardRef(({
  type = 'text',
  mask = '9 9 9 9',
  defaultStyle,
  ...otherProps
}, ref) => (
  <FormFieldMaskedContainer
    ref={ref}
    alwaysShowMask
    className={cn({ [`--${defaultStyle}`]: defaultStyle })}
    mask={mask}
    type={type}
    {...otherProps}
  />
));

FormFieldMasked.displayName = 'FormFieldMasked';

export default FormFieldMasked;
